import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import { getActiveCrawlerSection } from '@hydra/utils/parseRouteParams';

import IssueCounterRow from '@hydra/routes/crawler/components/IssueCounterRow';

export class IndexingCategory extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    params: PropTypes.shape({
      lang: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    project: PropTypes.shape({
      host: PropTypes.string,
      crawl: PropTypes.shape({
        indexingCategory: PropTypes.shape({
          countNoindexedPages: PropTypes.number,
          countNofollowedPages: PropTypes.number,
          countDisallowedPages: PropTypes.number,
          countDeepPages: PropTypes.number
        })
      })
    }),
    location: PropTypes.object,
    url: PropTypes.string
  }

  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext () {
    return {
      location: this.props.location
    };
  }

  getCounters (props) {
    const { lang, url } = props.params;
    const activeSection = getActiveCrawlerSection(props.routes);
    const baseUrl = `/${lang}/crawler/${encodeURIComponent(url)}/indexing`;
    const crawlNode = get(props, 'project.crawls.edges[0].node', {});

    return [
      {
        active: activeSection === 'non-indexable-pages',
        amount: crawlNode.countNoindexedPages || 0,
        label: <Translate content='crawler_non_indexed_pages' />,
        link: `${baseUrl}/non-indexable-pages`,
        name: 'non-indexable-pages'
      },
      {
        active: activeSection === 'disallowed-pages',
        amount: crawlNode.countDisallowedPages || 0,
        label: <Translate content='crawler_disallowed_pages' />,
        link: `${baseUrl}/disallowed-pages`,
        name: 'disallowed-pages'
      },
      {
        active: activeSection === 'no-followed-pages',
        amount: crawlNode.countNofollowedPages || 0,
        label: <Translate content='crawler_no_followed_pages' />,
        link: `${baseUrl}/no-followed-pages`,
        name: 'no-followed-pages'
      },
      {
        active: activeSection === 'deep-pages',
        amount: crawlNode.countDeepPages || 0,
        label: <Translate content='crawler_deep_pages' />,
        link: `${baseUrl}/deep-pages`,
        name: 'deep-pages'
      }
    ];
  }

  render () {
    const { children } = this.props;

    return (
      <div className='nr-crawler-indexing-category'>
        <IssueCounterRow counters={this.getCounters(this.props)} />
        {children}
      </div>
    );
  }
}

export default createFragmentContainer(IndexingCategory, {
  project: graphql`
    fragment IndexingCategory_project on Project {
      host
      crawls (offset: 0, limit: 1) {
        edges {
          cursor,
          node {
            countNoindexedPages
            countNofollowedPages
            countDisallowedPages
            countDeepPages
          }
        }
      }
    }
  `
});
